/**
 * @generated SignedSource<<63a25abed6e98a695e4c4914e7193a29>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LessonKind = "ARTICLE" | "AUDIO_ARTICLE" | "COMMENTARY" | "MINI_STORY" | "POV" | "VOCABULARY" | "%future added value";
export type TranscriptStatus = "FAILED" | "PENDING" | "READY" | "%future added value";
export type LessonSetViewQuery$variables = {
  localDay: any;
  setId: string;
};
export type LessonSetViewQuery$data = {
  readonly me: {
    readonly learner: {
      readonly defaultCharacter: {
        readonly audience: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly node: {
    readonly day?: number | null | undefined;
    readonly daysPlayed?: number;
    readonly id?: string;
    readonly lessons?: ReadonlyArray<{
      readonly answerReady: boolean;
      readonly completedToday: boolean;
      readonly id: string;
      readonly kind: LessonKind;
      readonly part: string | null | undefined;
      readonly playsToday: number;
      readonly transcriptStatus: TranscriptStatus | null | undefined;
    }>;
    readonly level?: number | null | undefined;
    readonly name?: string;
    readonly startedAt?: any | null | undefined;
  } | null | undefined;
};
export type LessonSetViewQuery = {
  response: LessonSetViewQuery$data;
  variables: LessonSetViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "localDay"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "setId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audience",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "setId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "level",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startedAt",
  "storageKey": null
},
v8 = [
  {
    "kind": "Variable",
    "name": "localDay",
    "variableName": "localDay"
  }
],
v9 = {
  "alias": null,
  "args": (v8/*:: as any*/),
  "kind": "ScalarField",
  "name": "day",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "daysPlayed",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Lesson",
  "kind": "LinkedField",
  "name": "lessons",
  "plural": true,
  "selections": [
    (v4/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "part",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "answerReady",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transcriptStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v8/*:: as any*/),
      "kind": "ScalarField",
      "name": "playsToday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v8/*:: as any*/),
      "kind": "ScalarField",
      "name": "completedToday",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "LessonSetViewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/)
            ],
            "type": "LessonSet",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "LessonSetViewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v4/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/)
            ],
            "type": "LessonSet",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "776f6ce6b77e9d98f647cff7c78804a1",
    "id": null,
    "metadata": {},
    "name": "LessonSetViewQuery",
    "operationKind": "query",
    "text": "query LessonSetViewQuery(\n  $setId: ID!\n  $localDay: NaiveDate!\n) {\n  me {\n    learner {\n      defaultCharacter {\n        audience\n        id\n      }\n      id\n    }\n  }\n  node(id: $setId) {\n    __typename\n    ... on LessonSet {\n      id\n      name\n      level\n      startedAt\n      day(localDay: $localDay)\n      daysPlayed\n      lessons {\n        id\n        kind\n        part\n        answerReady\n        transcriptStatus\n        playsToday(localDay: $localDay)\n        completedToday(localDay: $localDay)\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "fae4c0465a6c81ca577cae41547953e9";

export default node;
